import { render, staticRenderFns } from "./CrudeOilPrice.vue?vue&type=template&id=2b318a1c"
import script from "./CrudeOilPrice.vue?vue&type=script&lang=js"
export * from "./CrudeOilPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports